import React from "react";
import styled from "styled-components";

interface FlexProps {
  gapSize?: number;
  children: React.ReactNode;
  [key: string]: any;
}

interface SFlexContainer {
  gapSize?: number;
}

export default function Flex({ children, gapSize, ...rest }: FlexProps) {
  return (
    <FlexContainer gapSize={gapSize} {...rest}>
      {children}
    </FlexContainer>
  );
}

const FlexContainer = styled.div<SFlexContainer>`
  display: flex;
  align-items: center;
  column-gap: ${({ gapSize }) => `${gapSize ?? 0}px` ?? "unset"};
  gap: ${({ gapSize }) => `${gapSize ?? 0}px` ?? "unset"};
`;
